import SparklesIcon from '@mui/icons-material/AutoAwesome';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';

const ClinicalTrialCard = () => {
  return (
    <div className='space-y-4'>
      <div className='flex items-center justify-center gap-2'>
        <div className='h-px flex-1 bg-border' />
        <span className='text-xs text-muted-foreground px-2'>본 진료와 무관한 정보입니다</span>
        <span className='badge badge-outline text-[10px] px-1.5 py-0.5 font-medium bg-white'>광고</span>
        <div className='h-px flex-1 bg-border' />
      </div>

      <h3 className='text-lg font-bold text-foreground'>
        환자 분의 두통에 딱 맞는 임상 연구가 진행 중입니다
      </h3>

      <div className='space-y-3'>
        <p className='text-muted-foreground text-sm'>
          전문 의료진의 케어와 함께 의학 발전에 기여하실 수 있습니다.
        </p>

        <div className='flex flex-wrap gap-1.5'>
          <span className='badge badge-outline text-xs font-normal text-muted-foreground bg-white'>신약</span>
          <span className='badge badge-outline text-xs font-normal text-muted-foreground bg-white'>건강기능식품</span>
          <span className='badge badge-outline text-xs font-normal text-muted-foreground bg-white'>피부·미용</span>
          <span className='badge badge-outline text-xs font-normal text-muted-foreground bg-white'>AI 디지털 치료기기</span>
        </div>

        <div className='flex flex-wrap gap-2'>
          <span className='badge badge-secondary flex items-center gap-1.5 px-3 py-1.5'>
            <SparklesIcon className='!w-4 !h-4' />
            <span>새로운 치료법 경험</span>
          </span>
          <span className='badge badge-secondary flex items-center gap-1.5 px-3 py-1.5'>
            <LocalAtmIcon className='!w-4 !h-4' />
            <span>참여 시 소정의 사례비(교통비) 지급</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ClinicalTrialCard;
